import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";

import Slider from "react-slick";
import { Link } from "react-router-dom";
import { Clock, MapPin, User } from "react-feather";
import HiringCard from "./HiringCard";
import { PRIMARY_TEXT_COLOR } from "../color";

const TopHiring = ({ jobsData }) => {


  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 1000,
    pauseOnHover: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1245, // Adjust this breakpoint according to your needs
        settings: {
          slidesToShow: 3, // Number of slides to show in mobile view
        },
      },
      {
        breakpoint: 996, // Adjust this breakpoint according to your needs
        settings: {
          slidesToShow: 2, // Number of slides to show in mobile view
        },
      },
      {
        breakpoint: 567, // Adjust this breakpoint according to your needs
        settings: {
          slidesToShow: 1, // Number of slides to show in mobile view
        },
      },
    ],
  };
  console.log("Jobs data", jobsData)
  return (
    <div className="" style={{ backgroundColor: "#fdfdfe" }}>
      <div className="container ">

        <div className="py-5 ">
          <div className="">
            <h4 className="text-center mb-3 section-title text-dark">
              Featured Jobs
            </h4>
            <p className="px-md-0 px-2 text-center mb-2" style={{ color: PRIMARY_TEXT_COLOR }}>
              {/* We have assembled some of top picks occupations in a single spot
            <br /> to help fabricate the career that accommodates your existence
            with best assets */}
              Discover audit jobs conveniently in one place . <br /> Find your ideal
              role and take the next step in your career.
            </p>
          </div>
          {
            jobsData.length > 0 &&
            <div className="slider-container mx-md-5">
              <Slider {...settings}>
                {jobsData.map((item, index) => {
                  return (
                    <div key={index} >
                      <HiringCard job={item} />
                    </div>
                  )
                })}
              </Slider>
            </div>
          }

          <div className="col-12 text-center mt-4">
            <a href="/jobs-opening-list" className="btn btn-common">
              Browse All Audit Jobs
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHiring;

{
  /* <div className="slider-container mx-md-5">
<Slider {...settings}>
  {data.map((item, index) => (
    // <div key={index} className="p-3 ">
    //   <div className=" shadow bg-white p-2 position-relative" style={{height:'180px'}}>
    //     <p className="text-right">{item.date}</p>
    //     <p className="d-flex justify-content-between flex-wrap">
    //       <p
    //         className="text-dark text-truncate"
    //         style={{ fontSize: "1.2rem", fontWeight: "bold" }}
    //       >
    //         {item.title}
    //       </p>

    //       <p>
    //         {" "}
    //         <span
    //           className={`py-1 px-2  font-size-2 ${
    //             item.type === "Full-time"
    //               ? "LightBlueWhite"
    //               : "BlueGreen"
    //           }`}
    //         >
    //           {/* <Clock size={12} /> {" "} */
}
//           {item.type}
//         </span>{" "}
//       </p>
//     </p>

//     <p>
//       {" "}
//       <span className="text-success">
//         <User size={15} />
//       </span>{" "}
//       {item.positions} years
//     </p>

//     <p>
//       {" "}
//       <span className="text-success">
//         <MapPin size={15} />
//       </span>{" "}
//       {item.location}
//     </p>

//     <p className="text-right position-absolute" style={{bottom:10,right:10}} >
//       <button className="cancelBtn py-0">View</button>
//     </p>
//   </div>
// </div>
// <HiringCard job={item}/>
// ))}
// </Slider>
// </div> */}

/*
    {data.map((item, index) => (
              <div key={index} className="p-3 ">
                <div className=" shadow bg-white p-2 position-relative" style={{height:'180px'}}>
                  <p className="text-right font-size-2">{moment().diff(moment(item.fld_openingdate).format('ll'), 'days')} day ago</p>
                  <p className="d-flex justify-content-between flex-wrap">
                    <p
                      className="text-dark text-truncate"
                      style={{ fontSize: "1.2rem", fontWeight: "bold" }}
                    >
                      {item.fld_title} 
                    </p>

                    <p>
                      {" "}
                      <span
                        className={`py-1 px-2 font-size-2 ${
                          item.type === "Full-time"
                            ? "LightBlueWhite"
                            : "BlueGreen"
                        }`}
                      >
                        {item.fld_type}
                      </span>
                    </p>
                  </p>

                  <p>
                    {" "}
                    <span className="text-success">
                      <User size={15} />
                    </span>{" "}
                    {item.fld_positions} years
                  </p>

                  <p>
                    {" "}
                    <span className="text-success">
                      <MapPin size={15} />
                    </span>{" "}
                    {item.fld_city}, {item.fld_state}
                  </p>

                  <p className="text-right position-absolute" style={{bottom:10,right:10}} >
                    <button className="btn btn-common px-3 py-1" style={{fontSize:"10px"}}>View</button>
                  </p>
                </div>
              </div>
            ))}
            */
